<template>
<div id="logs-settings" style="display:none;">
	<h3>Logs</h3>
	<div>
		<p>It would have taken away too much time to make a logs transfer utility. I both drastically changed how logs work, and moving information from http and https can be complicated. If anyone wants to make a logs transfer utility, I did start one at http://2018chat.rphaven.com/logs-transfer.html if anyone wants to finish it.</p>
		<p>It may be easier to just make it output them as JSON and have a way to copy in JSON into the new system that adds messages to the new client-side database</p>
		<p>I'll make this look as pretty as I feel inside later</p>
		<p v-html="logsResponseMsg" />
		<ul style="display:inline-block; vertical-align:top; min-width:120px;">
			<li v-for="(row, userid) in logsUsers"
				:key="userid" class="clickable"
				@click="selectUser(userid)"
			>
				<span v-show="!usersCache[userid]">{{ userid }}</span><span v-show="usersCache[userid]">{{ usersCache[userid].props.name }}</span>
			</li>
		</ul>
		<ul style="display:inline-block; vertical-align:top; min-width:200px;">
			<li v-for="(pair, index) in pairs"
				:key="index" class="clickable"
				@click="selectPair(pair)"
			>
				<span class="index">{{ pair.count }}</span><span v-if="typeof usersCache[pair.otherid] === 'undefined'">{{ pair.otherid }}</span><span v-else-if="typeof usersCache[pair.otherid] !== 'undefined'">{{ usersCache[pair.otherid].props.name }}</span>
				<div>last: {{ makeTimestamp(pair.last) }}</div>
			</li>
		</ul>
		<ul style="display:inline-block;">
			<li
				v-for="msg in msgs" :key="msg.date"
			>
				{{ makeTimestamp(msg.date) }} <span v-if="typeof usersCache[msg.fromid] === 'undefined'">{{ msg.fromid }}</span><span v-else-if="typeof usersCache[msg.fromid] !== 'undefined'">{{ usersCache[msg.fromid].props.name }}</span>: {{ msg.msg }}
			</li>
		</ul>
	</div>
</div>
</template>

<script>

import { makeTimestamp } from '../js/shared/common-functions.js'
import { db } from '../js/db.js'

export default {
	props: ['logsResponseMsg', 'logsUsers'],
	data: () => ({
		pairs: [],
		msgs: [],
		usersCache: messenger.users // remove from global...
	}),
	methods: {
		selectUser: function( userid ){
			this.pairs = this.logsUsers[userid]
			this.pairs.forEach( ( pair ) => { // fetch for the user cache...
				if( typeof messenger.users[pair.otherid] === 'undefined' ){
					getUserById( pair.otherid )
				}
			})
		},
		selectPair: function( pair ){
			db.msgs.where({userid: pair.userid, otherid: pair.otherid})
				.toArray()
				.then( ( rows ) => {
					this.msgs = rows
				})
		},
		makeTimestamp: makeTimestamp
	}
}
</script>